import gql from 'graphql-tag'

export const getPresentationQuery = gql`
    query getPresentation($eventId: EventID!, $filters: PresentationSpaceFilter) {
        event(id:$eventId) {
            presentationSpaces(filters: $filters) {
                edges {
                    node {
                        id
                        streamIsContinues
                        streamUrl
                        interactionIsContinues
                        interactionUrl
                        showAttendees
                        parent {
                            id
                            slug
                            enableChat
                            helpContent
                            helpContentType
                            name
                            image
                            published
                        }
                    }
                }
            }
        }
    }
`
